const { default: axiosInstance } = require('../axiosInstance');

const getAllUsers = async () => {
  return axiosInstance.get('/user').then((response) => {
    return response.data;
  });
};

const getUserById = async (userId) => {
  return axiosInstance.get(`/user/${userId}`).then((response) => {
    return response.data;
  });
};

const getUserByInviteToken = async (token) => {
  return axiosInstance.get(`/user/invite/${token}`).then((response) => {
    return response.data;
  });
};

const createUser = async (user) => {
  return axiosInstance.post('/user', user).then((response) => {
    return response.data;
  });
};

const updateUser = async (user) => {
  return axiosInstance.put(`/user/${user.id}`, user).then((response) => {
    return response.data;
  });
};

const deleteUser = async (userId) => {
  return axiosInstance.delete(`/user/${userId}`).then((response) => {
    return response.data;
  });
};

const inviteUser = async (data) => {
  return axiosInstance.post(`/user/invite`, data).then((response) => {
    return response.data;
  });
};

const verifyInviteToken = async (data) => {
  return axiosInstance.put(`/user/invite`, data).then((response) => {
    return response.data;
  });
};

const getUserName = async (id) => {
  return axiosInstance.get(`/user/name/${id}`).then((response) => {
    return response.data;
  });
};

const getProfile = async () => {
  return axiosInstance.get('/user/profile').then((response) => {
    return response.data;
  });
};

const updateProfile = async (profile) => {
  return axiosInstance.put('/user/profile', profile).then((response) => {
    return response.data;
  });
};

const requestPasswordReset = async (email) => {
  return axiosInstance
    .post('/user/password-reset/request', {
      email
    })
    .then((response) => {
      return response.data;
    });
};

const resetPasswordWithToken = async (token, password) => {
  return axiosInstance
    .post('/user/password-reset/confirm', {
      token,
      password
    })
    .then((response) => {
      return response.data;
    });
};

const getRegistrationSettings = async () => {
  return axiosInstance.get('/user/registration-settings').then((response) => {
    return response.data;
  });
};

const updateRegistrationSettings = async (settings) => {
  return axiosInstance.put('/user/registration-settings', settings).then((response) => {
    return response.data;
  });
};

const checkRegistrationEmail = async (email) => {
  return axiosInstance.post('/user/registration-check', { email }).then((response) => {
    return response.data;
  });
};

const getSystemSettings = async () => {
  return axiosInstance.get('/settings/system').then((response) => {
    return response.data;
  });
};

const updateSystemSettings = async (settings) => {
  return axiosInstance.put('/settings/system', settings).then((response) => {
    return response.data;
  });
};

const userService = {
  getAllUsers,
  getUserById,
  getUserByInviteToken,
  createUser,
  updateUser,
  deleteUser,
  inviteUser,
  verifyInviteToken,
  getUserName,
  getProfile,
  updateProfile,
  requestPasswordReset,
  resetPasswordWithToken,
  getRegistrationSettings,
  updateRegistrationSettings,
  checkRegistrationEmail,
  getSystemSettings,
  updateSystemSettings
};

export default userService;
